const MoreVerticalIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.5 17C13.6046 17 14.5 17.8954 14.5 19C14.5 20.1046 13.6046 21 12.5 21C11.3954 21 10.5 20.1046 10.5 19C10.5 17.8954 11.3954 17 12.5 17ZM12.5 10C13.6046 10 14.5 10.8954 14.5 12C14.5 13.1046 13.6046 14 12.5 14C11.3954 14 10.5 13.1046 10.5 12C10.5 10.8954 11.3954 10 12.5 10ZM14.5 5C14.5 3.89543 13.6046 3 12.5 3C11.3954 3 10.5 3.89543 10.5 5C10.5 6.10457 11.3954 7 12.5 7C13.6046 7 14.5 6.10457 14.5 5Z"
			fill="currentColor"
		/>
	</svg>
)

export default MoreVerticalIcon
